import type { Transition, Variants } from 'framer-motion';

export enum MultiStateActionVariant {
    Initial = 'initial',
    Show = 'show',
    Exit = 'exit',
}

export const multiStateActionVariants: Variants = {
    [MultiStateActionVariant.Initial]: {
        opacity: 0,
        scale: 0.1,
    },
    [MultiStateActionVariant.Show]: {
        opacity: 1,
        scale: 1,
    },
    [MultiStateActionVariant.Exit]: {
        opacity: 0,
        scale: 0.1,
    },
};

export const multiStateActionTransition: Transition = {
    ease: 'easeInOut',
    duration: 0.16,
};
